import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountingManualSeat } from "src/models/Accounting/Accounting.models";

interface AccountingManualSeatState {
    manualSeats: IAccountingManualSeat[];
    manualSeatToEdit: IAccountingManualSeat | null;
}

const initialState: AccountingManualSeatState = {
    manualSeats: [],
    manualSeatToEdit: null,
};

const AccountingManualSeatSlice = createSlice({
    name: "AccountingManualSeat",
    initialState,
    reducers: {
    setAccountingManualSeatList: (
        state,
        action: PayloadAction<IAccountingManualSeat[]>
    ) => {
        state.manualSeats = action.payload;
    },
    concatListAccountingManualSeat: (
        state: AccountingManualSeatState,
        action: PayloadAction<IAccountingManualSeat[]>
    ) => {
        state.manualSeats = [
            ...state.manualSeats.concat(action.payload),
        ];
    },
    setAccountingManualSeatToEdit: (
        state,
        action: PayloadAction<IAccountingManualSeat | null>
    ) => {
        state.manualSeatToEdit = action.payload;
    },
    addAccountingManualSeat: (state, action: PayloadAction<IAccountingManualSeat>) => {
        state.manualSeats.push(action.payload);
    },
    updateAccountingManualSeat: (state, action: PayloadAction<IAccountingManualSeat>) => {
        let itemIndex = state.manualSeats.findIndex(
            item => item.manualSeatId === action.payload.manualSeatId
        );
        if (itemIndex !== -1) state.manualSeats[itemIndex] = action.payload;
    },
    deleteAccountingManualSeat: (state, action: PayloadAction<number>) => {
        const newArray = state.manualSeats.filter(
            item => item.manualSeatId !== action.payload
        );
        state.manualSeats = newArray;
    },
    },
});

export const {
    setAccountingManualSeatList,
    concatListAccountingManualSeat,
    setAccountingManualSeatToEdit,
    addAccountingManualSeat,
    updateAccountingManualSeat,
    deleteAccountingManualSeat,
} = AccountingManualSeatSlice.actions;

export default AccountingManualSeatSlice.reducer;